//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import lineChart from '@/components/charts/line-chart.vue';
import intervalChart from '@/components/charts/interval-chart.vue';
import barChart from '@/components/charts/bar-chart.vue';
import circleChart from '@/components/charts/circle-chart.vue';
import gaugeChart from '@/components/charts/gauge-chart.vue';
import pieChart from '@/components/charts/pie-chart.vue';

export default {
  components: {
    lineChart,
    intervalChart,
    barChart,
    circleChart,
    pieChart,
    gaugeChart
  },
  name: 'home',
  data() {
    return {
      tabname: 'gaugechart',
      chartId1: '',
      chartData1: [],
      chartId2: '',
      chartData2: [],
      chartId3: '',
      chartData3: [],
      chartId4: '',
      chartData4: [],
      chartId5: '',
      chartData5: [],
      chartId6: '',
      chartData6: []
    };
  },
  methods: {
    tabcharts(e) {
      this.tabname = e;
    },
    setLine: function() {
      this.chartId1 = 'chartone';
      this.chartData1 = [
        { name: '律师', date: '2018-01', value: 275 },
        { name: '律师', date: '2018-02', value: 115 },
        { name: '律师', date: '2018-03', value: 120 },
        { name: '律师', date: '2018-04', value: 350 },
        { name: '律师', date: '2018-05', value: 150 }
      ];
    },
    setinterval: function() {
      this.chartId2 = 'charttwo';
      this.chartData2 = [
        { year: '2014', value: 257 },
        { year: '2015', value: 280 },
        { year: '2016', value: 233 },
        { year: '2017', value: 160 },
        { year: '2018', value: 100 }
      ];
    },
    setbar: function() {
      this.chartId3 = 'chartthree';
      this.chartData3 = [
        { precent: 644, precentstring: '中国' },
        { precent: 870, precentstring: '法国' },
        { precent: 160, precentstring: '印度' },
        { precent: 343, precentstring: '巴西' },
        { precent: 590, precentstring: '俄罗斯' }
      ];
    },
    setcircle: function() {
      this.chartId4 = 'chartfour';
      this.chartData4 = [
        {
          item: '事例一',
          count: 40,
          percent: 0.4
        },
        {
          item: '事例二',
          count: 21,
          percent: 0.21
        },
        {
          item: '事例三',
          count: 17,
          percent: 0.17
        },
        {
          item: '事例四',
          count: 13,
          percent: 0.13
        },
        {
          item: '事例五',
          count: 9,
          percent: 0.09
        }
      ];
    },
    setpie: function() {
      (this.chartId5 = 'chartfive'),
        (this.chartData5 = [
          {
            item: '事例一',
            count: 40,
            percent: 0.4
          },
          {
            item: '事例二',
            count: 21,
            percent: 0.21
          },
          {
            item: '事例三',
            count: 17,
            percent: 0.17
          },
          {
            item: '事例四',
            count: 13,
            percent: 0.13
          },
          {
            item: '事例五',
            count: 9,
            percent: 0.09
          }
        ]);
    },
    setgauge: function() {
      this.chartId6 = 'chartsix';
      this.chartData6 = {
        start: 0,
        end: 100,
        name: '完成率',
        value: { value: 69 }
      };
    }
  },
  watch: {},
  created() {
    this.setLine();
    this.setinterval();
    this.setbar();
    this.setcircle();
    this.setpie();
    this.setgauge();
  },
  mounted() {}
};
